import React from 'react';
import UseContext from "hooks/useContext";
import Button from "components/button";

// variant "mission" for a mission sheet, "document" for a contract or a timesheet
const AccessDenied = ({variant = 'mission', onBack}) => {
    const {language} = UseContext();

    return (
        <div className="flex flex-col items-center justify-center text-center gap-3 py-16 px-6" role="alert">
            <h2 className="text-xl font-semibold text-gray-900">
                {language.getValue(`missionAccess.${variant}.title`)}
            </h2>
            <p className="text-sm text-gray-500 max-w-md">
                {language.getValue(`missionAccess.${variant}.description`)}
            </p>
            <Button size={'SM'} color={'SECONDARY'} onClick={onBack}>
                {language.getValue('missionAccess.back')}
            </Button>
        </div>
    );
};

export default AccessDenied;
